import CaseStudyNineContainer from "./containers/CaseStudyNineContainer";
export default CaseStudyNineContainer;
